import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  ModeofPayment,
  DueDateBasedOn,
  PaymentTermName,
  CreditDays,
  InvoicePortion,
  DiscountType,
  Discount,
  DiscountValidityBasedOn,
  DiscountValidity,
  Description,
}) => {
  return (
   <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    id="PaymentTermName"
                    label="Payment Term Name"
                    style={{
                      height: "30px",
                      border: PaymentTermName.Error ? "1px solid red" : "",
                    }}
                    value={PaymentTermName.value}
                    onChange={(e) =>
                      PaymentTermName.setValue(e.target.value)
                    }
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    id="InvoicePortion"
                    label="Invoice Portion (%)"
                    style={{
                      height: "30px",
                      border: InvoicePortion.Error ? "1px solid red" : "",
                    }}
                    value={InvoicePortion.value}
                    onChange={(e) => InvoicePortion.setValue(e.target.value)}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={ModeofPayment.ModeofPayment_list}
                    label="Mode of Payment"
                    getOptionLabel={(item) => item.name}
                    getOptionValue={(item) => item.name}
                    value={ModeofPayment.value}
                    onChange={(val) => ModeofPayment.setValue(val)}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={[
                      { name: "Day(s) after invoice date" },
                      { name: "Day(s) after the end of the invoice month" },
                      { name: "Month(s) after the end of the invoice month" },
                    ]}
                    label="Due Date Based On"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={DueDateBasedOn.value}
                    onChange={(val) => DueDateBasedOn.setValue(val)}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <Input
                    id="CreditDays"
                    label="Credit Days"
                    style={{
                      height: "30px",
                      // border: CreditDays.Error ? "1px solid red" : "",
                    }}
                    value={CreditDays.value}
                    onChange={(e) => CreditDays.setValue(e.target.value)}

                  />
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Discount Settings</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>


                <div style={{ flex: 1 }}>
                  <SelectSearch
                    list={[{ name: "Percentage" }, { name: "Amount" }]}
                    style={{
                      height: "30px",
                      border: DiscountType.Error ? "1px solid red" : "",
                    }}
                    label="Discount Type"
                    getOptionLabel={(item) => item.name} // 👈 Required
                    getOptionValue={(item) => item.name} // 👈 Required
                    value={DiscountType.value}
                    onChange={(val) => DiscountType.setValue(val)}
                  />
                </div>

                <div style={{ flex: 1 }}>

                  <Input
                    id="Discount"
                    label="Discount"
                    style={{
                      height: "30px",
                      // border: Discount.Error ? "1px solid red" : "",
                    }}
                    value={Discount.value}
                    onChange={(e) => Discount.setValue(e.target.value)}
                  />
                </div>
                {Discount.value !== "" && (
                  <>
                    <div style={{ flex: 1 }}>
                      <SelectSearch
                        list={[
                          { name: "Day(s) after invoice date" },
                          { name: "Day(s) after the end of the invoice month" },
                          { name: "Month(s) after the end of the invoice month" },
                        ]}
                        label="Discount Validity Based On"
                        getOptionLabel={(item) => item.name} // 👈 Required
                        getOptionValue={(item) => item.name} // 👈 Required
                        value={DiscountValidityBasedOn.value}
                        onChange={(val) => DiscountValidityBasedOn.setValue(val)}
                      />
                    </div>

                  </>
                )}
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                {Discount.value !== "" && (
                  <>

                    <div style={{ flex: 1 }}>
                      <Input
                        id="DiscountValidity"
                        label="Discount Validity"
                        style={{
                          height: "30px",
                          // border: Discount.Error ? "1px solid red" : "",
                        }}
                        value={DiscountValidity.value}
                        onChange={(e) => DiscountValidity.setValue(e.target.value)}
                      />
                    </div>
                  </>
                )}
                <div style={{ flex: 1 }}>
                  <Textarea
                    id="Description"
                    label="Description"
                    style={{
                      height: "30px",
                      border: Description.Error ? "1px solid red" : "",
                    }}
                    value={Description.value}
                    onChange={(e) => Description.setValue(e.target.value)}
                  />
                </div>


              </div>



            </div>
          </div>
        </div>
           <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

            <div className="col-md-12 px-2">
              <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


              <ActivityCard doctype="Payment Term" docname={IdData} />





              </div>
            </div>

          </div>
       
      </div>

    </div>
  );
};

export default Tab1;
